export default "__VITE_ASSET__DBMIU8Pi__"